import { Base } from "ui/Scripts/source/framework/base";
import { IIdRowId, IdRowId } from "ui/Scripts/source/models/common/idRowId";
import { ApiSuccess, IApiSuccess } from "ui/Scripts/source/models/common/apiSuccess";

export interface IUnitModuleSaveResult extends IApiSuccess {
    rowIds: IIdRowId[];
}

export class UnitModuleSaveResult extends ApiSuccess implements IUnitModuleSaveResult {
    rowIds: IdRowId[];

    constructor();
    constructor(obj: IUnitModuleSaveResult);
    constructor(obj?: any) {
        super(obj);
        this.rowIds = Base.getTypedArray(obj ? obj.rowIds : null, IdRowId);
    }
}